import React from "react";
import { withRouter } from "react-router-dom";

class BaiduTrack extends React.Component<any> {
    componentDidMount() {
        const key = "0b63168dbdaa8679d5ca7a0e1fd15587";
        const hm = document.createElement("script");
        hm.src = `https://hm.baidu.com/hm.js?${key}`;
        const s = document.getElementsByTagName("script")[0];
        // @ts-ignore
        s.parentNode.insertBefore(hm, s);
    }

    componentDidUpdate(prevProps: any) {
        // @ts-ignore
        const _hmt = window._hmt;
        _hmt && _hmt.push(["_trackPageview", this.props.location.pathname]);
    }

    render() {
        return null;
    }
}

// @ts-ignore
export default withRouter(BaiduTrack);
